import { SOCKET_CONNECTION_STATUSES } from '@/comments/comments.utils';

export function getInitialState () {
    return {
        drawerOpen: false,
        connectionStatus: SOCKET_CONNECTION_STATUSES.PENDING,
    };
}

const pendoCollaboration = {
    namespaced: true,
    state: getInitialState(),
    mutations: {
        setDrawerOpen (state, { drawerOpen }) {
            state.drawerOpen = drawerOpen;
        },
        setConnectionStatus (state, { status }) {
            state.connectionStatus = status;
        },
    },
    actions: {
        toggleDrawer ({ commit, state }) {
            commit('setDrawerOpen', { drawerOpen: !state.drawerOpen });
        },
        teardown ({ state }) {
            Object.assign(state, getInitialState());
        },
        setConnectionStatus ({ commit }, { status }) {
            commit('setConnectionStatus', { status });
        },
    },
    getters: {
        hasPendoCollaboration: () => {
            return true;
        },
        getConnectionStatus: (state) => {
            return state.connectionStatus;
        },
    },
};

export default pendoCollaboration;
